// Tipos de dominio del gráfico de signos vitales compartido por 018A
// (Transanestésico) y 019 (Cuidados Post-Anestésicos) — Fase 1B, ver
// PLAN.md. Sin JSX ni recharts (mismo criterio que `graficos/tipos.ts`).
//
// Decisión de diseño (marcada en PLAN.md antes de codear): los 7 parámetros
// acá listados NO se persisten como `Observation` — viven solo en el estado
// del formulario y en el diagrama bespoke del PDF (`DatosSignosVitalesPdf`
// en `@logiacare/hce-pdf`). Respiración/torniquete/feto (categóricos, solo
// en 018A) no entran acá — se capturan aparte como texto/checklist.
import { MINUTO_MAX_SIGNOS_VITALES, type ParametroSignosVitalesAnestesia, type TipoEventoAnestesia } from '@logiacare/hce-pdf';

export interface MedicionPuntual {
  readonly id: string;
  readonly parametro: ParametroSignosVitalesAnestesia;
  readonly minuto: number;
  readonly valor: number;
}

export interface EventoAnestesia {
  readonly id: string;
  readonly tipo: TipoEventoAnestesia;
  readonly minuto: number;
}

export interface DefinicionParametro {
  readonly clave: ParametroSignosVitalesAnestesia;
  readonly etiqueta: string;
  readonly unidad: string;
}

export const CATALOGO_PARAMETROS: readonly DefinicionParametro[] = [
  { clave: 'tas', etiqueta: 'TAS', unidad: 'mmHg' },
  { clave: 'tad', etiqueta: 'TAD', unidad: 'mmHg' },
  { clave: 'tam', etiqueta: 'TAM', unidad: 'mmHg' },
  { clave: 'fc', etiqueta: 'FC', unidad: 'lpm' },
  { clave: 'temperatura', etiqueta: 'Temperatura', unidad: '°C' },
  { clave: 'pvc', etiqueta: 'PVC', unidad: 'cmH2O' },
  { clave: 'sato2', etiqueta: 'SatO2', unidad: '%' },
];

export const CATALOGO_EVENTOS: readonly { readonly clave: TipoEventoAnestesia; readonly etiqueta: string }[] = [
  { clave: 'inicio-anestesia', etiqueta: 'Inicio anestesia' },
  { clave: 'induccion', etiqueta: 'Inducción' },
  { clave: 'inicio-cirugia', etiqueta: 'Inicio cirugía' },
  { clave: 'fin-cirugia', etiqueta: 'Fin cirugía' },
  { clave: 'fin-anestesia', etiqueta: 'Fin anestesia' },
];

/**
 * Tope de minutos del gráfico: el papel de 018A trae 9 bloques horarios (540 min) y el de 019 trae 6 (360 min). Es el mismo tope que
 * el PDF firmado dibuja (`MINUTO_MAX_SIGNOS_VITALES`); cada formulario puede bajarlo con la prop `minutoMax` del gráfico.
 */
export const MINUTO_MAX = MINUTO_MAX_SIGNOS_VITALES;
/** 019 (Cuidados post-anestésicos): 6 bloques horarios en el papel. */
export const MINUTO_MAX_019 = 360;

/** Un minuto es válido si es un número finito dentro de [0, máximo]. */
export function minutoValido(minuto: number, maximo: number = MINUTO_MAX): boolean {
  return Number.isFinite(minuto) && minuto >= 0 && minuto <= maximo;
}
